import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=7c5c487a&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=7c5c487a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5c487a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c5c487a')) {
      api.createRecord('7c5c487a', component.options)
    } else {
      api.reload('7c5c487a', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=7c5c487a&scoped=true&", function () {
      api.rerender('7c5c487a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ClVeeerS0W6F/JS/comp/Paginate.vue"
export default component.exports